import { useState, useEffect, useRef } from 'react';
import { setAccessToken, authApi, api } from '../utils/api.js';

/* ─── Icons ─── */
const IconEye = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
  </svg>
);
const IconEyeOff = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);
const IconAlert = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink:0, marginTop:1 }}>
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);
const IconCheck = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconArrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
  </svg>
);
const IconBack = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
  </svg>
);
const IconMail = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="2,4 12,13 22,4"/>
  </svg>
);
const IconTag = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
    <line x1="7" y1="7" x2="7.01" y2="7"/>
  </svg>
);
const IconX = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);
const IconShield = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);
const IconLock = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
  </svg>
);
const IconGoogle = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);
const IconUsers = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
  </svg>
);
const IconStar = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

/* ─── Enhanced Input with validation states ─── */
function Input({ label, type = 'text', value, onChange, placeholder, autoFocus, onHintClick, hintLabel, validState, validMsg }) {
  const [focused, setFocused] = useState(false);
  const [touched, setTouched] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const isPass = type === 'password';
  const inputType = isPass ? (showPwd ? 'text' : 'password') : type;

  const getState = () => {
    if (!touched && !validState) return 'idle';
    if (validState) return validState; // 'success' | 'error' | 'warning'
    return 'idle';
  };
  const state = getState();

  const borderColor = focused
    ? state === 'error' ? 'rgba(240,90,90,0.8)'
    : state === 'success' ? 'rgba(46,204,138,0.7)'
    : 'rgba(212,168,67,0.65)'
    : state === 'error' ? 'rgba(240,90,90,0.35)'
    : state === 'success' ? 'rgba(46,204,138,0.3)'
    : 'rgba(255,255,255,0.09)';

  const bgColor = focused
    ? state === 'error' ? 'rgba(240,90,90,0.04)'
    : state === 'success' ? 'rgba(46,204,138,0.03)'
    : 'rgba(212,168,67,0.04)'
    : 'rgba(255,255,255,0.025)';

  const glowColor = focused
    ? state === 'error' ? '0 0 0 3px rgba(240,90,90,0.08)'
    : state === 'success' ? '0 0 0 3px rgba(46,204,138,0.07)'
    : '0 0 0 3px rgba(212,168,67,0.08)'
    : 'none';

  const labelColor = focused
    ? state === 'error' ? '#f87171'
    : state === 'success' ? '#2dd4a0'
    : 'var(--c-gold)'
    : state === 'error' ? 'rgba(248,113,113,0.7)'
    : state === 'success' ? 'rgba(45,212,160,0.6)'
    : 'var(--c-muted)';

  return (
    <div style={{ marginBottom: 18 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:7 }}>
        <label style={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '0.07em',
          textTransform: 'uppercase',
          color: labelColor,
          fontFamily: 'var(--f-mono)',
          transition: 'color 0.2s'
        }}>{label}</label>
        {hintLabel && (
          <span
            onClick={onHintClick}
            style={{ fontSize:11, color:'var(--c-gold)', fontFamily:'var(--f-body)', cursor:'pointer', opacity:0.75, transition:'opacity 0.15s' }}
            onMouseEnter={e => e.currentTarget.style.opacity = '1'}
            onMouseLeave={e => e.currentTarget.style.opacity = '0.75'}
          >{hintLabel}</span>
        )}
      </div>
      <div style={{ position:'relative' }}>
        <input
          type={inputType} value={value} onChange={onChange} placeholder={placeholder} autoFocus={autoFocus}
          onFocus={() => setFocused(true)}
          onBlur={() => { setFocused(false); setTouched(true); }}
          style={{
            width: '100%',
            padding: '12px 16px',
            paddingRight: isPass ? '46px' : '16px',
            background: bgColor,
            border: '1px solid',
            borderColor: borderColor,
            borderRadius: '9px',
            color: 'var(--c-text)',
            fontSize: 14,
            fontFamily: 'var(--f-body)',
            fontWeight: 400,
            outline: 'none',
            transition: 'border-color 0.2s, background 0.2s, box-shadow 0.2s',
            boxShadow: glowColor,
            boxSizing: 'border-box',
          }}
        />
        {isPass && (
          <button
            type="button"
            onClick={() => setShowPwd(v => !v)}
            style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color: showPwd ? 'var(--c-gold)' : 'rgba(255,255,255,0.25)', display:'flex', padding:0, transition:'color 0.15s' }}
          >
            {showPwd ? <IconEyeOff /> : <IconEye />}
          </button>
        )}
        {state === 'success' && !isPass && (
          <span style={{ position:'absolute', right:13, top:'50%', transform:'translateY(-50%)', color:'#2dd4a0', display:'flex', pointerEvents:'none' }}>
            <IconCheck />
          </span>
        )}
      </div>
      {validMsg && (
        <p style={{ marginTop:5, fontSize:11, fontFamily:'var(--f-body)', color: state === 'error' ? '#f87171' : state === 'success' ? '#2dd4a0' : 'var(--c-muted)', transition:'color 0.2s' }}>
          {validMsg}
        </p>
      )}
    </div>
  );
}

/* ─── OTP Input ─── */
function OtpInput({ value, onChange }) {
  const r0 = useRef(null);
  const r1 = useRef(null);
  const r2 = useRef(null);
  const r3 = useRef(null);
  const r4 = useRef(null);
  const r5 = useRef(null);
  const refs = [r0, r1, r2, r3, r4, r5];

  const digits = (value || '').padEnd(6, ' ').split('').slice(0, 6);

  const focusNext = (i) => { if (i < 5) refs[i + 1]?.current?.focus(); };
  const focusPrev = (i) => { if (i > 0) refs[i - 1]?.current?.focus(); };

  const handleKeyDown = (i, e) => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      const cur = digits[i].trim();
      if (cur) {
        const next = digits.map((d, idx) => idx === i ? ' ' : d).join('');
        onChange(next.trimEnd());
      } else {
        focusPrev(i);
        const next = digits.map((d, idx) => idx === i - 1 ? ' ' : d).join('');
        onChange(next.trimEnd());
      }
    } else if (e.key === 'ArrowLeft')  focusPrev(i);
    else if   (e.key === 'ArrowRight') focusNext(i);
  };

  const handleChange = (i, e) => {
    const raw = e.target.value.replace(/\D/g, '');
    if (!raw) return;
    if (raw.length >= 6) {
      const pasted = raw.slice(0, 6);
      onChange(pasted);
      refs[5]?.current?.focus();
      return;
    }
    const ch = raw.slice(-1);
    const next = digits.map((d, idx) => idx === i ? ch : d).join('').trimEnd();
    onChange(next);
    focusNext(i);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (!pasted) return;
    onChange(pasted);
    refs[Math.min(pasted.length, 5)]?.current?.focus();
  };

  const displayVal = (d) => d.trim();

  return (
    <div style={{ display:'flex', gap:8, justifyContent:'center', margin:'20px 0 24px' }}>
      {digits.map((d, i) => {
        const filled = d.trim() !== '';
        return (
          <input
            key={i}
            ref={refs[i]}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            value={displayVal(d)}
            autoFocus={i === 0}
            className="otp-box"
            onChange={e => handleChange(i, e)}
            onKeyDown={e => handleKeyDown(i, e)}
            onPaste={handlePaste}
            style={{
              width: '46px',
              height: '56px',
              minWidth: '46px',
              minHeight: '56px',
              flexShrink: 0,
              textAlign: 'center',
              fontSize: 26,
              fontWeight: 700,
              lineHeight: '56px',
              fontFamily: 'var(--f-mono)',
              color: filled ? 'var(--c-gold)' : 'rgba(237,232,222,0.3)',
              background: filled ? 'rgba(212,168,67,0.09)' : 'rgba(255,255,255,0.025)',
              border: '1.5px solid',
              borderColor: filled ? 'rgba(212,168,67,0.5)' : 'rgba(255,255,255,0.09)',
              borderRadius: '10px',
              outline: 'none',
              caretColor: 'var(--c-gold)',
              transition: 'border-color 0.15s, background 0.15s, color 0.15s, box-shadow 0.15s',
              padding: 0,
              boxSizing: 'border-box',
              display: 'block',
            }}
            onFocus={e => {
              e.target.style.borderColor = 'rgba(212,168,67,0.75)';
              e.target.style.boxShadow   = '0 0 0 3px rgba(212,168,67,0.1)';
              e.target.style.background  = 'rgba(212,168,67,0.07)';
              e.target.select();
            }}
            onBlur={e => {
              const f = e.target.value.trim() !== '';
              e.target.style.borderColor = f ? 'rgba(212,168,67,0.5)' : 'rgba(255,255,255,0.09)';
              e.target.style.boxShadow   = 'none';
              e.target.style.background  = f ? 'rgba(212,168,67,0.09)' : 'rgba(255,255,255,0.025)';
            }}
          />
        );
      })}
    </div>
  );
}

/* ─── Password strength indicator ─── */
const PWD_RULES = [
  { id:'len',     label:'8+ characters',      test: p => p.length >= 8 },
  { id:'upper',   label:'Uppercase letter',    test: p => /[A-Z]/.test(p) },
  { id:'num',     label:'Number',              test: p => /[0-9]/.test(p) },
  { id:'special', label:'Special character',  test: p => /[^A-Za-z0-9]/.test(p) },
];

function getStrengthLevel(pwd) {
  if (!pwd) return 0;
  const passed = PWD_RULES.filter(r => r.test(pwd)).length;
  return passed; // 0-4
}

function PasswordStrength({ pwd }) {
  const level = getStrengthLevel(pwd);
  const label = ['', 'Weak', 'Fair', 'Good', 'Strong'][level] || '';
  const color  = ['', '#f87171', '#FBBF24', '#60a5fa', '#2dd4a0'][level] || 'transparent';

  if (!pwd) return null;

  return (
    <div style={{ marginTop: -6, marginBottom: 14 }}>
      {/* strength bar */}
      <div style={{ display:'flex', gap:4, marginBottom:8 }}>
        {[1,2,3,4].map(i => (
          <div key={i} style={{
            flex:1, height:3, borderRadius:99,
            background: i <= level ? color : 'rgba(255,255,255,0.07)',
            transition: 'background 0.3s',
          }}/>
        ))}
      </div>
      {/* rules checklist */}
      <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
        {PWD_RULES.map((rule, i) => {
          const ok = rule.test(pwd);
          return (
            <div key={rule.id} style={{ display:'flex', alignItems:'center', gap:7, fontSize:11.5, fontFamily:'var(--f-body)', color: ok ? '#2dd4a0' : 'rgba(237,232,222,0.35)', transition:'color 0.25s' }}>
              <span style={{
                width: 15, height: 15, borderRadius: '50%', flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 9, fontWeight: 700,
                background: ok ? 'rgba(45,212,160,0.15)' : 'rgba(255,255,255,0.05)',
                border: `1px solid ${ok ? 'rgba(45,212,160,0.4)' : 'rgba(255,255,255,0.1)'}`,
                color: ok ? '#2dd4a0' : 'rgba(255,255,255,0.2)',
                transition: 'all 0.25s',
              }}>
                {ok ? '✓' : '·'}
              </span>
              {rule.label}
              {level > 0 && i === 4 - 1 && (
                <span style={{ marginLeft:'auto', fontSize:10, fontFamily:'var(--f-mono)', fontWeight:700, color, letterSpacing:'0.05em', opacity:0.9 }}>{label}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ─── Referral coupon ─── */
function ReferralCoupon({ refCode, setRefCode, refValid, setRefValid, setRefBanner }) {
  const [open,     setOpen]     = useState(!!refCode);
  const [input,    setInput]    = useState(refCode || '');
  const [checking, setChecking] = useState(false);
  const [refError, setRefError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => { if (open && inputRef.current) inputRef.current.focus(); }, [open]);
  useEffect(() => { if (refCode && !refValid) handleApply(refCode); }, []); // eslint-disable-line

  const handleOpen   = () => { setOpen(true); setRefError(''); };
  const handleCancel = () => { setOpen(false); setInput(''); setRefError(''); setRefCode(''); setRefValid(false); };

  const handleApply = async (codeToCheck) => {
    const code = (codeToCheck || input).trim().toUpperCase();
    if (!code) { setRefError('Please enter a referral code.'); return; }
    setChecking(true); setRefError('');
    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL || 'http://localhost:5000/api'}/referral/validate?code=${encodeURIComponent(code)}`, { headers:{'Content-Type':'application/json'} });
      if (!res.ok) throw new Error('Invalid referral code. Please check and try again.');
      setRefCode(code); setRefValid(true); if (setRefBanner) setRefBanner(''); setOpen(false);
    } catch (e) {
      setRefError(e.message || 'Invalid referral code.'); setRefValid(false);
    } finally { setChecking(false); }
  };

  const onKey = e => { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); handleApply(); } };

  if (refValid && refCode) return (
    <div style={{ marginBottom:16, display:'flex', alignItems:'center', gap:8 }}>
      <div style={{ display:'inline-flex', alignItems:'center', gap:7, background:'rgba(45,212,160,0.08)', border:'1px solid rgba(45,212,160,0.25)', borderRadius:6, padding:'6px 12px', fontSize:12, color:'#2dd4a0', fontFamily:'var(--f-mono)', fontWeight:600 }}>
        <IconCheck/><span>{refCode} applied — <strong>5% off</strong> any premium plan 🎉</span>
      </div>
      <button onClick={handleCancel} title="Remove" style={{ background:'none', border:'none', cursor:'pointer', color:'rgba(232,228,220,0.3)', display:'flex', padding:2 }} onMouseOver={e=>e.currentTarget.style.color='#f87171'} onMouseOut={e=>e.currentTarget.style.color='rgba(232,228,220,0.3)'}><IconX/></button>
    </div>
  );

  if (!open) return (
    <div style={{ marginBottom:16 }}>
      <button onClick={handleOpen} style={{ background:'none', border:'none', cursor:'pointer', padding:0, display:'inline-flex', alignItems:'center', gap:6, fontSize:12, color:'rgba(196,160,90,0.7)', fontFamily:'var(--f-body)', fontWeight:500, borderBottom:'1px solid rgba(196,160,90,0.25)', paddingBottom:1 }}>
        <IconTag/> Apply referral code
      </button>
    </div>
  );

  return (
    <div style={{ marginBottom:16 }}>
      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
        <input ref={inputRef} value={input} onChange={e=>{setInput(e.target.value.toUpperCase());setRefError('');}} onKeyDown={onKey} placeholder="KFX-XXXXXXXX" maxLength={12}
          style={{ flex:1, background:'none', border:'none', borderBottom:`1px solid ${refError?'#f87171':'rgba(196,160,90,0.5)'}`, borderRadius:0, padding:'6px 2px', color:'var(--c-text)', fontSize:13, fontFamily:'var(--f-mono)', fontWeight:500, letterSpacing:'0.08em', outline:'none' }}/>
        <button onClick={()=>handleApply()} disabled={checking||!input.trim()} style={{ background:'none', border:'none', cursor: checking||!input.trim()?'not-allowed':'pointer', padding:'4px 0', fontSize:11, fontWeight:700, letterSpacing:'0.08em', color: checking||!input.trim()?'rgba(196,160,90,0.3)':'var(--c-gold)', fontFamily:'var(--f-mono)', textTransform:'uppercase', borderBottom:'1px solid', borderColor: checking||!input.trim()?'rgba(196,160,90,0.15)':'rgba(196,160,90,0.4)', whiteSpace:'nowrap' }}>
          {checking?'…':'Apply'}
        </button>
        <button onClick={handleCancel} style={{ background:'none', border:'none', cursor:'pointer', display:'flex', alignItems:'center', padding:4, color:'rgba(232,228,220,0.3)' }} onMouseOver={e=>e.currentTarget.style.color='rgba(232,228,220,0.7)'} onMouseOut={e=>e.currentTarget.style.color='rgba(232,228,220,0.3)'}><IconX/></button>
      </div>
      {refError && <div style={{ marginTop:6, fontSize:11, color:'#f87171', fontFamily:'var(--f-body)', display:'flex', alignItems:'center', gap:5 }}><IconAlert/>{refError}</div>}
    </div>
  );
}

/* ─── Trust badges strip ─── */
function TrustStrip() {
  const badges = [
    { icon: <IconShield />, label: 'SSL Encrypted' },
    { icon: <IconLock />,   label: 'Privacy First' },
    { icon: <IconUsers />,  label: '5,000+ Traders' },
  ];
  return (
    <div className="trust-strip" style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:0, marginTop:18, marginBottom:2 }}>
      {badges.map((b, i) => (
        <div key={i} style={{ display:'flex', alignItems:'center', gap:5, padding:'0 12px', borderRight: i < badges.length - 1 ? '1px solid rgba(255,255,255,0.07)' : 'none', fontSize:11, fontFamily:'var(--f-mono)', color:'rgba(237,232,222,0.28)', letterSpacing:'0.04em', whiteSpace:'nowrap' }}>
          <span style={{ color:'rgba(212,168,67,0.4)', display:'flex' }}>{b.icon}</span>
          {b.label}
        </div>
      ))}
    </div>
  );
}

/* ─── Social proof chip ─── */
function SocialProof() {
  return (
    <div className="social-proof-row" style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, marginBottom:20 }}>
      {/* avatars */}
      <div style={{ display:'flex' }}>
        {['#C9971A','#5B8FE8','#2ECC8A','#E05555'].map((c, i) => (
          <div key={i} style={{
            width: 22, height: 22, borderRadius: '50%',
            background: `${c}22`, border: `1.5px solid ${c}55`,
            marginLeft: i === 0 ? 0 : -6,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 9, fontWeight: 700, color: c,
            zIndex: 4 - i,
            position: 'relative',
          }}>
            {['JM','AK','R','TO'][i]}
          </div>
        ))}
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:3 }}>
        {[1,2,3,4,5].map(s => (
          <span key={s} style={{ color:'#D4A843', fontSize:9 }}><IconStar /></span>
        ))}
      </div>
      <span style={{ fontSize:11, fontFamily:'var(--f-mono)', color:'rgba(237,232,222,0.38)', letterSpacing:'0.03em' }}>
        Trusted by <strong style={{ color:'rgba(212,168,67,0.8)', fontWeight:600 }}>5,000+</strong> traders
      </span>
    </div>
  );
}

/* ─── Brand panel (left side, desktop only) ───
   Signature element: a mocked journal entry — the actual unit of
   value in a trading journal — instead of abstract decoration. */
function BrandPanel() {
  const sparkPoints = '0,40 26,33 52,37 78,23 104,27 130,13 156,19 182,9 208,15';
  return (
    <div className="auth-brand">
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:40 }}>
        <img
          src="/src/images/kfxlogo.png"
          alt="KFX Journal"
          style={{ width:30, height:30, borderRadius:7, objectFit:'contain' }}
          onError={e => { e.target.style.display='none'; }}
        />
        <span style={{ fontSize:16, fontWeight:800, color:'var(--c-text)', letterSpacing:'-0.02em' }}>KFX Journal</span>
      </div>

      <h2 style={{ fontSize:32, fontWeight:800, color:'var(--c-text)', letterSpacing:'-0.03em', lineHeight:1.18, marginBottom:14 }}>
        Every trade.<br/>Every lesson.<br/>Logged.
      </h2>
      <p style={{ fontSize:13.5, color:'var(--c-muted)', lineHeight:1.75, maxWidth:340 }}>
        Stop relying on memory. KFX Journal turns your trade history into the
        patterns that actually move your edge forward.
      </p>

      {/* ── Signature: sample journal entry ── */}
      <div className="ticket-card">
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:14 }}>
          <div>
            <div style={{ fontSize:14, fontWeight:700, color:'var(--c-text)', letterSpacing:'-0.01em' }}>EUR/USD</div>
            <div style={{ fontSize:11, fontFamily:'var(--f-mono)', color:'var(--c-muted)', letterSpacing:'0.04em', marginTop:2 }}>
              1.0842 → 1.0918
            </div>
          </div>
          <span style={{ fontSize:10.5, fontWeight:700, letterSpacing:'0.08em', color:'var(--c-green)', background:'rgba(46,204,138,0.1)', border:'1px solid rgba(46,204,138,0.25)', borderRadius:6, padding:'4px 9px', fontFamily:'var(--f-mono)' }}>
            LONG
          </span>
        </div>

        <div style={{ display:'flex', alignItems:'baseline', justifyContent:'space-between', marginBottom:12 }}>
          <span style={{ fontSize:11, fontFamily:'var(--f-mono)', color:'var(--c-muted)', letterSpacing:'0.06em', textTransform:'uppercase' }}>Result</span>
          <span style={{ fontSize:20, fontWeight:800, color:'var(--c-green)', fontFamily:'var(--f-mono)', letterSpacing:'-0.01em' }}>+2.4R</span>
        </div>

        <svg viewBox="0 0 208 50" preserveAspectRatio="none" style={{ width:'100%', height:44, display:'block' }} aria-hidden>
          <polyline points={sparkPoints} fill="none" stroke="var(--c-gold)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

        <div className="ticket-stats">
          <div className="ticket-stat">
            <div style={{ fontSize:9.5, fontFamily:'var(--f-mono)', color:'var(--c-muted)', letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:4 }}>Win rate</div>
            <div style={{ fontSize:14, fontWeight:700, color:'var(--c-text)', fontFamily:'var(--f-mono)' }}>64%</div>
          </div>
          <div className="ticket-stat">
            <div style={{ fontSize:9.5, fontFamily:'var(--f-mono)', color:'var(--c-muted)', letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:4 }}>Avg R</div>
            <div style={{ fontSize:14, fontWeight:700, color:'var(--c-text)', fontFamily:'var(--f-mono)' }}>+1.8R</div>
          </div>
          <div className="ticket-stat">
            <div style={{ fontSize:9.5, fontFamily:'var(--f-mono)', color:'var(--c-muted)', letterSpacing:'0.08em', textTransform:'uppercase', marginBottom:4 }}>Streak</div>
            <div style={{ fontSize:14, fontWeight:700, color:'var(--c-text)', fontFamily:'var(--f-mono)' }}>5W</div>
          </div>
        </div>
      </div>

      <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:28, fontSize:11, fontFamily:'var(--f-mono)', color:'rgba(237,232,222,0.3)', letterSpacing:'0.04em' }}>
        <div style={{ display:'flex' }}>
          {['#C9971A','#5B8FE8','#2ECC8A','#E05555'].map((c, i) => (
            <div key={i} style={{ width:18, height:18, borderRadius:'50%', background:`${c}22`, border:`1.5px solid ${c}55`, marginLeft: i === 0 ? 0 : -5 }}/>
          ))}
        </div>
        Trusted by <strong style={{ color:'rgba(212,168,67,0.8)', fontWeight:600 }}>5,000+</strong> traders
      </div>
    </div>
  );
}

/* ═══════════════════════════════════════════════
   Main AuthPage
═══════════════════════════════════════════════ */
export default function AuthPage({ onLogin, onBack, initialMode = 'login', onNavigate }) {
  const [mode,    setMode]   = useState(initialMode);
  const [name,    setName]   = useState('');
  const [email,   setEmail]  = useState('');
  const [pwd,     setPwd]    = useState('');
  const [confirm, setConf]   = useState('');
  const [error,   setError]  = useState('');
  const [success, setSuccess] = useState('');
  const [loading,       setLoading]       = useState(false);
  const [visible,       setVisible]       = useState(false);
  const [submitted,     setSubmitted]     = useState(false);
  const [lockedMinutes, setLockedMinutes] = useState(0);
  const [showPwdStrength, setShowPwdStrength] = useState(false);

  // Referral
  const [refCode,  setRefCode]  = useState('');
  const [refValid, setRefValid] = useState(false);
  const [refBanner,setRefBanner]= useState('');

  // Verification
  const [pendingUserId,  setPendingUserId]  = useState(null);
  const [pendingEmail,   setPendingEmail]   = useState('');
  const [otp,            setOtp]            = useState('');
  const [resendCooldown, setResendCooldown] = useState(0);

  useEffect(() => {
    if (resendCooldown <= 0) return;
    const t = setTimeout(() => setResendCooldown(s => s - 1), 1000);
    return () => clearTimeout(t);
  }, [resendCooldown]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref && ref.startsWith('KFX-')) { setRefCode(ref); setRefBanner('You have a referral code! Validating…'); setMode('signup'); }
    else if (window.location.pathname === '/register') setMode('signup');
  }, []);

  // ── Google OAuth success redirect handler ─────────────────
  // NOTE: Removed — this is now handled exclusively in App.jsx, which is
  // always mounted regardless of which page (AuthPage/LandingPage) renders.
  // Having it in both places caused a race: whichever effect ran second
  // would find the token already consumed and the URL already cleaned.

  useEffect(() => { const t = setTimeout(() => setVisible(true), 80); return () => clearTimeout(t); }, []);

  const reset    = () => { setError(''); setSuccess(''); setName(''); setEmail(''); setPwd(''); setConf(''); setSubmitted(false); setLockedMinutes(0); setShowPwdStrength(false); };
  const switchTo = m  => { setMode(m); reset(); };

  // ── Google OAuth ───────────────────────────────────────────
  const handleGoogleLogin = () => {
    window.location.href = `${import.meta.env.VITE_API_URL || 'http://localhost:5000'}/auth/google`;
  };

  // ── Login ──────────────────────────────────────────────────
  const handleLogin = async () => {
    setError(''); setSuccess('');
    if (!email.trim()) return setError('Please enter your email address.');
    if (!pwd)          return setError('Please enter your password.');
    setLoading(true);
    try {
      const data = await authApi.login(email.trim(), pwd);
      setAccessToken(data.accessToken);
      let isNew = false;
      try { const p = await api('/profile'); isNew = !p.profile?.level; } catch {}
      onLogin({ ...data.user, isNew });
    } catch (e) {
      if (e.code === 'EMAIL_NOT_VERIFIED' || e.needsVerification) {
        setPendingUserId(e.userId); setPendingEmail(email.trim()); setOtp(''); setMode('verify'); setError('');
      } else if (e.status === 429) {
        const mins = e.remainingMin ?? 60; setLockedMinutes(mins);
        setError(e.message || `Too many failed attempts. Please wait ${mins} minute${mins!==1?'s':''}.`);
      } else { setLockedMinutes(0); setError(e.message || 'Incorrect email or password.'); }
    } finally { setLoading(false); }
  };

  // ── Sign up ────────────────────────────────────────────────
  const handleSignup = async () => {
    setError(''); setSuccess(''); setSubmitted(true);
    if (!name.trim() || name.trim().length < 2) return setError('Please enter your full name (at least 2 characters).');
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email.trim())) return setError('Please enter a valid email address.');
    if (!pwd || pwd.length < 8)    return setError('Password must be at least 8 characters.');
    if (!/[A-Z]/.test(pwd))        return setError('Password needs at least one uppercase letter.');
    if (!/[0-9]/.test(pwd))        return setError('Password needs at least one number.');
    if (pwd !== confirm)           return setError('Passwords do not match.');
    setLoading(true);
    try {
      const urlRef = new URLSearchParams(window.location.search).get('ref');
      const codeToSend = (refValid && refCode) ? refCode : (urlRef?.startsWith('KFX-') ? urlRef : undefined);
      const data = await authApi.register(name.trim(), email.trim(), pwd, codeToSend);
      setPendingUserId(data.userId); setPendingEmail(email.trim()); setOtp(''); setResendCooldown(60); setMode('verify');
    } catch (e) {
      if (e.errors?.length) setError(e.errors.map(err => err.message).join(' · '));
      else if (e.message?.toLowerCase().includes('email')) setError('An account with this email already exists. Try signing in.');
      else setError(e.message || 'Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  // ── Verify ────────────────────────────────────────────────
  const handleVerify = async () => {
    setError('');
    const code = otp.replace(/\s/g, '');
    if (code.length < 6) return setError('Please enter all 6 digits.');
    setLoading(true);
    try {
      const data = await authApi.verifyEmail(pendingUserId, code);
      setAccessToken(data.accessToken);
      onLogin({ ...data.user, isNew: true });
    } catch (e) { setError(e.message || 'Verification failed. Please try again.'); }
    finally { setLoading(false); }
  };

  // ── Resend ────────────────────────────────────────────────
  const handleResend = async () => {
    if (resendCooldown > 0) return;
    setError(''); setSuccess('');
    try {
      await authApi.resendVerification(pendingUserId);
      setOtp(''); setSuccess('New code sent! Check your inbox.'); setResendCooldown(60);
    } catch (e) { setError(e.message || 'Could not resend code.'); }
  };

  // ── Forgot password ───────────────────────────────────────
  const handleForgotPassword = async () => {
    setError(''); setSuccess('');
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email.trim())) return setError('Please enter a valid email address.');
    setLoading(true);
    try {
      await api('/auth/forgot-password', { method:'POST', body: JSON.stringify({ email: email.trim() }) });
      setMode('forgot-sent');
    } catch (e) {
      if (e.errors?.length) setError(e.errors.map(err => err.message).join(' · '));
      else setError(e.message || 'Something went wrong. Please try again.');
    } finally { setLoading(false); }
  };

  const onEnter = e => {
    if (e.key !== 'Enter') return; e.preventDefault();
    if (mode==='login')  handleLogin();
    if (mode==='signup') handleSignup();
    if (mode==='forgot') handleForgotPassword();
    if (mode==='verify') handleVerify();
  };

  const Spinner = () => (
    <span style={{ width:14, height:14, border:'2px solid rgba(11,13,17,0.2)', borderTopColor:'rgba(11,13,17,0.6)', borderRadius:'50%', animation:'auth-spin 0.7s linear infinite', display:'inline-block', flexShrink:0 }}/>
  );

  const ErrorBanner = ({ msg }) => msg ? (
    <div style={{ display:'flex', alignItems:'flex-start', gap:10, padding:'11px 14px', marginBottom:18, background:'rgba(245,101,101,0.07)', border:'1px solid rgba(245,101,101,0.18)', borderRadius:9, color:'#fca5a5', fontSize:13, fontFamily:'var(--f-body)', lineHeight:1.55, animation:'banner-in 0.2s ease' }}>
      <IconAlert/><span>{msg}</span>
    </div>
  ) : null;

  const SuccessBanner = ({ msg }) => msg ? (
    <div style={{ display:'flex', alignItems:'center', gap:10, padding:'11px 14px', marginBottom:18, background:'rgba(45,212,160,0.07)', border:'1px solid rgba(45,212,160,0.18)', borderRadius:9, color:'#6ee7c7', fontSize:13, fontFamily:'var(--f-body)', lineHeight:1.55, animation:'banner-in 0.2s ease' }}>
      <IconCheck/><span style={{ marginLeft:2 }}>{msg}</span>
    </div>
  ) : null;

  /* heading & subtitle per mode */
  const headings = {
    login:        ['Welcome back',        'Sign in to your KFX Journal account'],
    signup:       ['Start for free',      'Free forever · No credit card needed'],
    forgot:       ['Reset password',      "We'll send a reset link to your email"],
    'forgot-sent':['Check your inbox',    'A password reset link was sent'],
    verify:       ['Verify your email',   `We sent a 6-digit code to ${pendingEmail}`],
  };
  const [heading, subtitle] = headings[mode] || ['', ''];

  const showTabs = mode === 'login' || mode === 'signup';

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,400;12..96,500;12..96,600;12..96,700;12..96,800&family=DM+Mono:wght@400;500&display=swap');

        :root {
          --c-bg:#09090d;
          --c-panel:#12141a;
          --c-surface:#111318;
          --c-surface-2:#161a22;
          --c-border:rgba(255,255,255,0.07);
          --c-hairline:rgba(255,255,255,0.06);
          --c-gold:#D4A843;
          --c-gold-lt:#F0C855;
          --c-gold-dk:#a0803a;
          --c-text:#EDE8DE;
          --c-muted:rgba(237,232,222,0.42);
          --c-green:#2ECC8A;
          --c-red:#f56565;
          --f-body:'Bricolage Grotesque',sans-serif;
          --f-mono:'DM Mono',monospace;
          --radius:9px;
          --t:0.2s cubic-bezier(0.4,0,0.2,1);
        }

        *,*::before,*::after { box-sizing:border-box; margin:0; padding:0; }
        body { background:var(--c-bg); }

        input:-webkit-autofill, input:-webkit-autofill:focus {
          -webkit-box-shadow: 0 0 0 1000px #111318 inset !important;
          -webkit-text-fill-color: #EDE8DE !important;
          caret-color: #EDE8DE;
        }
        input::placeholder { color:rgba(237,232,222,0.18); }

        @keyframes auth-up {
          from { opacity:0; transform:translateY(18px) }
          to   { opacity:1; transform:none }
        }
        @keyframes auth-spin { to { transform:rotate(360deg) } }
        @keyframes auth-pulse {
          0%,100% { opacity:1; box-shadow:0 0 0 0 rgba(46,204,138,0.5) }
          60%     { opacity:.6; box-shadow:0 0 0 5px rgba(46,204,138,0) }
        }
        @keyframes verify-in {
          from { opacity:0; transform:translateY(10px) }
          to   { opacity:1; transform:none }
        }
        @keyframes banner-in {
          from { opacity:0; transform:translateY(-4px) }
          to   { opacity:1; transform:none }
        }
        @keyframes tab-slide {
          from { transform:scaleX(0) }
          to   { transform:scaleX(1) }
        }

        .auth-card { animation: auth-up 0.42s cubic-bezier(0.16,1,0.3,1) both; }
        .verify-animate { animation: verify-in 0.3s cubic-bezier(0.16,1,0.3,1) both; }

        /* ── Premium CTA button ── */
        .kfx-btn-primary {
          width:100%; padding:14px; min-height:50px;
          background: linear-gradient(135deg, #D4A843 0%, #b8922d 60%, #9a7828 100%);
          border: none; border-radius: var(--radius);
          color: #0b0d11; font-size: 12px; font-weight: 700;
          letter-spacing: 0.09em; text-transform: uppercase;
          font-family: var(--f-mono); cursor: pointer;
          transition: transform 0.2s cubic-bezier(0.34,1.56,0.64,1),
                      box-shadow 0.2s ease,
                      background 0.2s ease;
          box-shadow: 0 2px 12px rgba(212,168,67,0.22),
                      0 1px 0 rgba(255,255,255,0.15) inset;
          display: flex; align-items: center; justify-content: center; gap: 10px;
          position: relative; overflow: hidden;
        }
        .kfx-btn-primary::before {
          content: '';
          position: absolute;
          top: 0; left: -100%; width: 100%; height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
          transition: left 0.5s ease;
        }
        .kfx-btn-primary:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 32px rgba(212,168,67,0.35),
                      0 1px 0 rgba(255,255,255,0.15) inset;
          background: linear-gradient(135deg, #F0C855 0%, #D4A843 60%, #b8922d 100%);
        }
        .kfx-btn-primary:hover::before { left: 100%; }
        .kfx-btn-primary:active:not(:disabled) {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(212,168,67,0.2);
        }
        .kfx-btn-primary:disabled {
          background: rgba(212,168,67,0.1);
          color: rgba(11,13,17,0.35);
          cursor: not-allowed;
          box-shadow: none;
        }

        /* ── Segmented tab control ── */
        .kfx-tabs-wrap {
          display: flex;
          background: rgba(0,0,0,0.4);
          border: 1px solid rgba(255,255,255,0.06);
          border-radius: 9px;
          padding: 3px;
          margin-bottom: 24px;
          position: relative;
        }
        .kfx-tab {
          flex: 1; padding: 9px 0; border: none; background: transparent;
          border-radius: 7px; font-size: 11px; font-weight: 700;
          letter-spacing: 0.08em; text-transform: uppercase;
          font-family: var(--f-mono); cursor: pointer;
          transition: color 0.2s; color: rgba(237,232,222,0.28);
          position: relative; z-index: 1;
        }
        .kfx-tab.active {
          color: var(--c-gold);
        }
        .kfx-tab:not(.active):hover { color: rgba(237,232,222,0.52); }

        /* sliding pill */
        .kfx-tab-pill {
          position: absolute;
          top: 3px; bottom: 3px;
          width: calc(50% - 3px);
          background: rgba(212,168,67,0.1);
          border: 1px solid rgba(212,168,67,0.2);
          border-radius: 7px;
          transition: left 0.22s cubic-bezier(0.34,1.3,0.64,1);
          pointer-events: none;
        }

        /* ── Link style ── */
        .kfx-link {
          color: var(--c-gold); cursor: pointer; font-weight: 600;
          text-decoration: none; border-bottom: 1px solid rgba(212,168,67,0.25);
          padding-bottom: 1px; transition: color var(--t), border-color var(--t);
        }
        .kfx-link:hover { color: var(--c-gold-lt); border-color: rgba(240,200,85,0.5); }

        /* ── Card top gradient border ── */
        .card-top-line {
          height: 1px;
          background: linear-gradient(90deg, transparent 0%, rgba(212,168,67,0.6) 50%, transparent 100%);
          margin: -28px -28px 24px;
          display: block;
        }

        /* ── Split layout ── */
        .auth-layout { display:flex; flex:1; min-height:0; }
        .auth-brand {
          flex: 0 0 40%;
          max-width: 460px;
          background: var(--c-panel);
          border-right: 1px solid var(--c-hairline);
          padding: 56px 44px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          background-image: repeating-linear-gradient(
            to bottom,
            rgba(212,168,67,0.035) 0px,
            rgba(212,168,67,0.035) 1px,
            transparent 1px,
            transparent 28px
          );
        }
        .auth-form-side {
          flex: 1;
          display: flex; align-items: center; justify-content: center;
          padding: 32px 20px 60px;
          position: relative;
        }

        /* ── Trade ticket (signature element) ── */
        .ticket-card {
          background: var(--c-surface);
          border: 1px solid var(--c-hairline);
          border-radius: var(--radius);
          padding: 18px 20px;
          margin-top: 28px;
        }
        .ticket-stats { display:flex; margin-top:22px; }
        .ticket-stat { flex:1; padding-right:18px; border-right:1px solid var(--c-hairline); }
        .ticket-stat:last-child { border-right:none; padding-right:0; }
        .ticket-stat:not(:first-child) { padding-left:18px; }

        @media(max-width: 880px) {
          .auth-brand { display:none; }
          .auth-nav-logo { display:flex; }
        }

        .auth-nav-logo { display:none; }

        @media(max-width:480px) {
          .auth-nav    { padding: 13px 16px !important }
          .auth-inner  { padding: 20px 16px 40px !important }
          .auth-card-inner { padding: 22px 18px !important }
          .card-top-line { margin: -22px -18px 20px; }
        }

        /* OTP boxes responsive */
        @media(max-width:360px) {
          .otp-box { width: 38px !important; height: 48px !important; min-width: 38px !important; min-height: 48px !important; font-size: 22px !important; }
        }

        /* Trust strip wraps on mobile */
        @media(max-width:480px) {
          .trust-strip { flex-wrap: wrap !important; justify-content: center !important; gap: 8px !important; }
          .trust-strip > div { border-right: none !important; padding: 0 8px !important; }
        }

        /* Social proof */
        @media(max-width:380px) {
          .social-proof-row { flex-direction: column !important; align-items: center !important; gap: 6px !important; }
        }
        @media(min-width:881px) {
          .social-proof-row { display:none; }
        }

        /* Free perks row */
        @media(max-width:380px) {
          .free-perks-row { flex-direction: column !important; align-items: center !important; gap: 6px !important; }
        }

        /* Nav logo center stays centered */
        @media(max-width:360px) {
          .auth-nav-logo { max-width: 140px !important; }
          .auth-nav-logo span { font-size: 12px !important; }
        }
      `}</style>

      <div style={{ minHeight:'100dvh', display:'flex', flexDirection:'column', fontFamily:'var(--f-body)', background:'var(--c-bg)', color:'var(--c-text)' }}>

        {/* ── Navbar ── */}
        <nav className="auth-nav" style={{ position:'relative', zIndex:10, display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 28px', borderBottom:'1px solid rgba(255,255,255,0.045)' }}>
          <button
            type="button"
            onClick={() => { if (onBack) onBack(); else window.location.href='/'; }}
            style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'6px 12px', borderRadius:7, border:'1px solid rgba(255,255,255,0.07)', background:'rgba(255,255,255,0.025)', color:'rgba(237,232,222,0.35)', fontSize:11, fontFamily:'var(--f-mono)', fontWeight:500, letterSpacing:'0.06em', cursor:'pointer', transition:'all var(--t)' }}
            onMouseEnter={e => { e.currentTarget.style.color='var(--c-gold)'; e.currentTarget.style.borderColor='rgba(212,168,67,0.25)'; e.currentTarget.style.background='rgba(212,168,67,0.05)'; }}
            onMouseLeave={e => { e.currentTarget.style.color='rgba(237,232,222,0.35)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.07)'; e.currentTarget.style.background='rgba(255,255,255,0.025)'; }}
          >
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
            Home
          </button>

          {/* Center logo — only shown on mobile, where the brand panel is hidden */}
          <div className="auth-nav-logo" style={{ alignItems:'center', gap:9, position:'absolute', left:'50%', transform:'translateX(-50%)' }}>
            <img
              src="/src/images/kfxlogo.png"
              alt="KFX Journal"
              style={{ width:27, height:27, borderRadius:7, objectFit:'contain' }}
              onError={e => { e.target.style.display='none'; }}
            />
            <span style={{ fontSize:14, fontWeight:800, color:'var(--c-text)', letterSpacing:'-0.02em' }}>KFX Journal</span>
          </div>

          {/* Live status */}
          <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:10.5, fontFamily:'var(--f-mono)', color:'rgba(46,204,138,0.6)', letterSpacing:'0.07em' }}>
            <span style={{ width:6, height:6, borderRadius:'50%', background:'var(--c-green)', animation:'auth-pulse 2.2s ease infinite', display:'inline-block', flexShrink:0 }}/>
            LIVE
          </div>
        </nav>

        {/* ── Split layout: brand panel + form ── */}
        <div className="auth-layout">
          <BrandPanel />

          {/* ── Form area ── */}
          <div
            className="auth-inner auth-form-side"
          >
          <div className="auth-card" style={{ width:'100%', maxWidth:432 }}>

            {/* Heading block */}
            {(mode === 'login' || mode === 'signup') && (
              <div style={{ textAlign:'center', marginBottom:6 }}>
                <SocialProof />
              </div>
            )}

            <div style={{ textAlign:'center', marginBottom:24 }}>
              <h1 style={{ fontSize:26, fontWeight:800, color:'var(--c-text)', letterSpacing:'-0.03em', lineHeight:1.15, marginBottom:7 }}>
                {heading}
              </h1>
              <p style={{ fontSize:12.5, color:'var(--c-muted)', fontFamily:'var(--f-mono)', letterSpacing:'0.02em' }}>
                {subtitle}
              </p>
            </div>

            {/* ── Auth card ── */}
            <div
              className="auth-card-inner"
              style={{
                background: 'var(--c-surface)',
                border: '1px solid var(--c-hairline)',
                borderRadius: 14,
                padding: '28px',
                boxShadow: '0 1px 0 rgba(212,168,67,0.06) inset',
              }}
            >
              {/* Gold top accent line */}
              <span aria-hidden className="card-top-line" />

              {/* ── Premium segmented tab control ── */}
              {showTabs && (
                <div className="kfx-tabs-wrap">
                  {/* sliding pill indicator */}
                  <div className="kfx-tab-pill" style={{ left: mode === 'login' ? '3px' : 'calc(50%)' }} />
                  <button className={`kfx-tab${mode==='login'?' active':''}`} onClick={() => switchTo('login')}>Sign In</button>
                  <button className={`kfx-tab${mode==='signup'?' active':''}`} onClick={() => switchTo('signup')}>Create Account</button>
                </div>
              )}

              {/* Back button for forgot flows */}
              {(mode === 'forgot' || mode === 'forgot-sent') && (
                <button
                  onClick={() => switchTo('login')}
                  style={{ display:'inline-flex', alignItems:'center', gap:6, background:'none', border:'none', cursor:'pointer', color:'var(--c-muted)', fontSize:11.5, fontFamily:'var(--f-mono)', letterSpacing:'0.05em', marginBottom:20, padding:0, transition:'color 0.2s' }}
                  onMouseOver={e => e.currentTarget.style.color='var(--c-gold)'}
                  onMouseOut={e  => e.currentTarget.style.color='var(--c-muted)'}
                >
                  <IconBack /> Back to sign in
                </button>
              )}

              <ErrorBanner  msg={error}   />
              <SuccessBanner msg={success} />

              {/* ════ LOGIN ════ */}
              {mode === 'login' && (
                <div onKeyDown={onEnter}>
                  <Input
                    label="Email"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    autoFocus
                  />
                  <Input
                    label="Password"
                    type="password"
                    value={pwd}
                    onChange={e => setPwd(e.target.value)}
                    placeholder="••••••••"
                    hintLabel="Forgot password?"
                    onHintClick={() => switchTo('forgot')}
                  />
                  <button
                    className="kfx-btn-primary"
                    onClick={handleLogin}
                    disabled={loading || lockedMinutes > 0}
                    style={{ marginTop:6 }}
                  >
                    {loading
                      ? <><Spinner /> Signing in…</>
                      : lockedMinutes > 0
                        ? `Locked · retry in ${lockedMinutes}m`
                        : <><span>Sign In</span><IconArrow /></>
                    }
                  </button>

                  {/* ── Divider ── */}
                  <div style={{ display:'flex', alignItems:'center', gap:12, margin:'18px 0 14px' }}>
                    <div style={{ flex:1, height:1, background:'rgba(255,255,255,0.07)' }}/>
                    <span style={{ fontSize:10.5, fontFamily:'var(--f-mono)', color:'rgba(237,232,222,0.25)', letterSpacing:'0.08em', textTransform:'uppercase' }}>or</span>
                    <div style={{ flex:1, height:1, background:'rgba(255,255,255,0.07)' }}/>
                  </div>

                  {/* ── Google button ── */}
                  <button
                    type="button"
                    onClick={handleGoogleLogin}
                    style={{ width:'100%', minHeight:46, display:'flex', alignItems:'center', justifyContent:'center', gap:10, padding:'11px 16px', background:'rgba(255,255,255,0.035)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'var(--radius)', cursor:'pointer', fontSize:12.5, fontWeight:600, fontFamily:'var(--f-body)', color:'var(--c-text)', letterSpacing:'0.01em', transition:'all 0.2s ease' }}
                    onMouseEnter={e => { e.currentTarget.style.background='rgba(255,255,255,0.07)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.18)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.035)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.1)'; }}
                  >
                    <IconGoogle /> Continue with Google
                  </button>

                  <p style={{ textAlign:'center', marginTop:18, fontSize:13, color:'var(--c-muted)' }}>
                    No account?{' '}
                    <span className="kfx-link" onClick={() => switchTo('signup')}>Start for free</span>
                  </p>
                </div>
              )}

              {/* ════ SIGNUP ════ */}
              {mode === 'signup' && (
                <div onKeyDown={onEnter}>
                  {refBanner && !refValid && (
                    <div style={{ display:'flex', alignItems:'center', gap:10, padding:'9px 14px', marginBottom:18, background:'rgba(212,168,67,0.06)', border:'1px solid rgba(212,168,67,0.18)', borderRadius:9, fontSize:12, color:'#D4A843', lineHeight:1.5 }}>
                      <span>🎁</span><span>{refBanner}</span>
                    </div>
                  )}

                  <Input label="Full Name"   value={name}    onChange={e => setName(e.target.value)}    placeholder="Jean Marie"  autoFocus />
                  <Input label="Email"       type="email" value={email}   onChange={e => setEmail(e.target.value)}   placeholder="you@example.com" />
                  <Input
                    label="Password"
                    type="password"
                    value={pwd}
                    onChange={e => { setPwd(e.target.value); setShowPwdStrength(true); }}
                    placeholder="Create a strong password"
                  />

                  {/* Password strength — shown once user starts typing */}
                  {(showPwdStrength || pwd.length > 0) && <PasswordStrength pwd={pwd} />}

                  <Input label="Confirm Password" type="password" value={confirm} onChange={e => setConf(e.target.value)} placeholder="••••••••" />
                  <ReferralCoupon refCode={refCode} setRefCode={setRefCode} refValid={refValid} setRefValid={setRefValid} setRefBanner={setRefBanner} />

                  <button
                    className="kfx-btn-primary"
                    onClick={handleSignup}
                    disabled={loading}
                    style={{ marginTop:4 }}
                  >
                    {loading ? <><Spinner /> Creating journal…</> : <><span>Create Free Journal</span><IconArrow /></>}
                  </button>

                  {/* Free perks reassurance */}
                  <div className="free-perks-row" style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:14, marginTop:14 }}>
                    {['Free forever', 'No card needed', 'Cancel anytime'].map((t, i) => (
                      <span key={i} style={{ display:'flex', alignItems:'center', gap:4, fontSize:10.5, fontFamily:'var(--f-mono)', color:'rgba(237,232,222,0.3)', letterSpacing:'0.03em' }}>
                        <span style={{ color:'rgba(45,212,160,0.5)', fontSize:9 }}>✓</span> {t}
                      </span>
                    ))}
                  </div>

                  {/* ── Divider ── */}
                  <div style={{ display:'flex', alignItems:'center', gap:12, margin:'16px 0 12px' }}>
                    <div style={{ flex:1, height:1, background:'rgba(255,255,255,0.07)' }}/>
                    <span style={{ fontSize:10.5, fontFamily:'var(--f-mono)', color:'rgba(237,232,222,0.25)', letterSpacing:'0.08em', textTransform:'uppercase' }}>or</span>
                    <div style={{ flex:1, height:1, background:'rgba(255,255,255,0.07)' }}/>
                  </div>

                  {/* ── Google button ── */}
                  <button
                    type="button"
                    onClick={handleGoogleLogin}
                    style={{ width:'100%', minHeight:46, display:'flex', alignItems:'center', justifyContent:'center', gap:10, padding:'11px 16px', background:'rgba(255,255,255,0.035)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:'var(--radius)', cursor:'pointer', fontSize:12.5, fontWeight:600, fontFamily:'var(--f-body)', color:'var(--c-text)', letterSpacing:'0.01em', transition:'all 0.2s ease' }}
                    onMouseEnter={e => { e.currentTarget.style.background='rgba(255,255,255,0.07)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.18)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background='rgba(255,255,255,0.035)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.1)'; }}
                  >
                    <IconGoogle /> Sign up with Google
                  </button>

                  <p style={{ textAlign:'center', marginTop:14, fontSize:13, color:'var(--c-muted)' }}>
                    Already have an account?{' '}
                    <span className="kfx-link" onClick={() => switchTo('login')}>Sign in</span>
                  </p>
                </div>
              )}

              {/* ════ VERIFY EMAIL ════ */}
              {mode === 'verify' && (
                <div className="verify-animate" onKeyDown={onEnter}>
                  {/* Envelope icon */}
                  <div style={{ display:'flex', justifyContent:'center', marginBottom:18 }}>
                    <div style={{ width:72, height:72, borderRadius:'50%', background:'rgba(196,160,90,0.07)', border:'1.5px solid rgba(196,160,90,0.18)', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 0 28px rgba(212,168,67,0.08)' }}>
                      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="var(--c-gold)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="2,4 12,13 22,4"/>
                      </svg>
                    </div>
                  </div>

                  <div style={{ textAlign:'center', marginBottom:4 }}>
                    <p style={{ fontSize:14, color:'var(--c-muted)', lineHeight:1.8 }}>
                      We sent a 6-digit code to
                    </p>
                    <p style={{ fontSize:14, fontWeight:700, color:'var(--c-gold)', letterSpacing:'0.01em', marginTop:2, wordBreak:'break-all' }}>
                      {pendingEmail}
                    </p>
                    <p style={{ fontSize:11.5, color:'rgba(237,232,222,0.28)', marginTop:6, fontFamily:'var(--f-mono)' }}>
                      Enter the code below to activate your account
                    </p>
                  </div>

                  <OtpInput value={otp} onChange={setOtp} />

                  <button
                    className="kfx-btn-primary"
                    onClick={handleVerify}
                    disabled={loading || otp.replace(/\s/g,'').length < 6}
                    style={{ marginTop:4 }}
                  >
                    {loading ? <><Spinner /> Verifying…</> : <><span>Verify Email</span><IconArrow /></>}
                  </button>

                  <p style={{ textAlign:'center', marginTop:16, fontSize:13, color:'var(--c-muted)' }}>
                    Didn't receive it?{' '}
                    {resendCooldown > 0
                      ? <span style={{ color:'rgba(212,168,67,0.38)', fontFamily:'var(--f-mono)', fontSize:12 }}>Resend in {resendCooldown}s</span>
                      : <span className="kfx-link" onClick={handleResend}>Resend code</span>
                    }
                  </p>
                  <p style={{ textAlign:'center', marginTop:8, fontSize:11.5, color:'rgba(237,232,222,0.22)' }}>
                    Wrong account?{' '}
                    <span className="kfx-link" style={{ fontSize:11.5 }} onClick={() => switchTo('login')}>Back to sign in</span>
                  </p>
                </div>
              )}

              {/* ════ FORGOT ════ */}
              {mode === 'forgot' && (
                <div onKeyDown={onEnter}>
                  <p style={{ fontSize:13, color:'var(--c-muted)', lineHeight:1.75, marginBottom:20 }}>
                    Enter your email and we'll send a reset link. Expires in{' '}
                    <strong style={{ color:'var(--c-text)' }}>15 minutes</strong>.
                  </p>
                  <Input label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" autoFocus />
                  <button className="kfx-btn-primary" onClick={handleForgotPassword} disabled={loading} style={{ marginTop:8 }}>
                    {loading ? <><Spinner /> Sending…</> : <><span>Send Reset Link</span><IconArrow /></>}
                  </button>
                </div>
              )}

              {/* ════ FORGOT SENT ════ */}
              {mode === 'forgot-sent' && (
                <div style={{ textAlign:'center', padding:'4px 0' }}>
                  <div style={{ width:56, height:56, borderRadius:'50%', background:'rgba(46,204,138,0.07)', border:'1px solid rgba(46,204,138,0.2)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 18px', color:'var(--c-green)', boxShadow:'0 0 24px rgba(46,204,138,0.08)' }}>
                    <IconMail />
                  </div>
                  <p style={{ fontSize:15, color:'var(--c-text)', fontWeight:700, marginBottom:10 }}>Reset link sent</p>
                  <p style={{ fontSize:13, color:'var(--c-muted)', lineHeight:1.8, marginBottom:22 }}>
                    If <strong style={{ color:'var(--c-text)' }}>{email || 'that email'}</strong> is registered with KFX Journal, a reset link is on its way. Check your spam folder too.
                  </p>
                  <p style={{ fontSize:11.5, color:'rgba(237,232,222,0.28)', fontFamily:'var(--f-mono)' }}>
                    Didn't arrive?{' '}
                    <span className="kfx-link" style={{ fontSize:11.5 }} onClick={() => switchTo('forgot')}>Resend</span>
                  </p>
                </div>
              )}

            </div>{/* end card-inner */}

            {/* ── Trust strip ── */}
            <TrustStrip />

            {/* ── Terms ── */}
            <p style={{ textAlign:'center', marginTop:14, fontSize:11, color:'rgba(237,232,222,0.16)', fontFamily:'var(--f-mono)', letterSpacing:'0.04em', lineHeight:1.7 }}>
              By continuing you agree to our{' '}
              <span style={{ borderBottom:'1px solid rgba(237,232,222,0.1)', cursor:'pointer', paddingBottom:1, transition:'color 0.15s' }}
                onClick={() => onNavigate && onNavigate('terms')}
                onMouseEnter={e => e.currentTarget.style.color='rgba(237,232,222,0.45)'}
                onMouseLeave={e => e.currentTarget.style.color=''}
              >Terms</span>
              {' '}and{' '}
              <span style={{ borderBottom:'1px solid rgba(237,232,222,0.1)', cursor:'pointer', paddingBottom:1, transition:'color 0.15s' }}
                onClick={() => onNavigate && onNavigate('privacy')}
                onMouseEnter={e => e.currentTarget.style.color='rgba(237,232,222,0.45)'}
                onMouseLeave={e => e.currentTarget.style.color=''}
              >Privacy Policy</span>
            </p>

          </div>
          </div>
        </div>
      </div>
    </>
  );
}